/**
 * Admin 360 URL for a customer — estimator and admin are sibling apps.
 *
 * Resolution (see @pazportal/ui resolveAppUrl): VITE_ADMIN_URL wins when
 * set; localhost swaps to port 3001; estimate.<domain> swaps to
 * admin.<domain>; anything else falls back to https://admin.paznetworks.com.
 */
import { resolveAppUrl } from '@pazportal/ui';

export function adminCustomerUrl(customerId: string): string {
  return resolveAppUrl('admin', `/customers/${customerId}`, {
    override: import.meta.env.VITE_ADMIN_URL || undefined,
  });
}
